import { Element as j, DoughnutController as we, Chart as st, Animations as Me } from "./index.es64.js";
import { d as Se, h as m, E as Q, t as w, P as b, aw as Ce, ay as ke, b as W, i as I, b4 as qt, x as kt, a0 as at, g as Ut, v as L, Q as pt, b5 as z, H as q, b6 as Pt, T as Gt, U as Pe, D as Tt, aF as bt, Y as Te, $ as De, a7 as X } from "./index.es116.js";
/*!
* chartjs-plugin-annotation v3.1.0
* https://www.chartjs.org/chartjs-plugin-annotation/index
 * (c) 2024 chartjs-plugin-annotation Contributors
 * Released under the MIT License
 */
const Dt = {
  modes: {
    /**
     * Point mode returns all elements that hit test based on the event position
     * @param {AnnotationElement[]} visibleElements - annotation elements which are visible
     * @param {ChartEvent} event - the event we are find things at
     * @return {AnnotationElement[]} - elements that are found
     */
    point(e, t) {
      return U(e, t, { intersect: !0 });
    },
    /**
     * Nearest mode returns the element closest to the event position
     * @param {AnnotationElement[]} visibleElements - annotation elements which are visible
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found (only 1 element)
     */
    nearest(e, t, o) {
      return Ye(e, t, o);
    },
    /**
     * x mode returns the elements that hit-test at the current x coordinate
     * @param {AnnotationElement[]} visibleElements - annotation elements which are visible
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found
     */
    x(e, t, o) {
      return U(e, t, { intersect: o.intersect, axis: "x" });
    },
    /**
     * y mode returns the elements that hit-test at the current y coordinate
     * @param {AnnotationElement[]} visibleElements - annotation elements which are visible
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found
     */
    y(e, t, o) {
      return U(e, t, { intersect: o.intersect, axis: "y" });
    }
  }
};
function gt(e, t, o) {
  return (Dt.modes[o.mode] || Dt.modes.nearest)(e, t, o);
}
function Ae(e, t, o) {
  return o !== "x" && o !== "y" ? e.inRange(t.x, t.y, "x", !0) || e.inRange(t.x, t.y, "y", !0) : e.inRange(t.x, t.y, o, !0);
}
function je(e, t, o) {
  return o === "x" ? { x: e.x, y: t.y } : o === "y" ? { x: t.x, y: e.y } : t;
}
function U(e, t, o) {
  return e.filter((n) => o.intersect ? n.inRange(t.x, t.y) : Ae(n, t, o.axis));
}
function Ye(e, t, o) {
  let n = Number.POSITIVE_INFINITY;
  return U(e, t, o).reduce((r, i) => {
    const s = i.getCenterPoint(), a = je(t, s, o.axis), d = bt(t, a);
    return d < n ? (r = [i], n = d) : d === n && r.push(i), r;
  }, []).sort((r, i) => r._index - i._index).slice(0, 1);
}
function Y(e, t, o) {
  const n = Math.cos(o), r = Math.sin(o), i = t.x, s = t.y;
  return {
    x: i + n * (e.x - i) - r * (e.y - s),
    y: s + r * (e.x - i) + n * (e.y - s)
  };
}
const Oe = (e, t) => t > e || e.length > t.length && e.slice(0, t.length) === t, D = 1e-3, K = (e, t, o) => Math.min(o, Math.max(t, e)), Qt = (e, t) => e.value >= e.start - t && e.value <= e.end + t;
function Xe(e, t, o) {
  for (const n of Object.keys(e))
    e[n] = K(e[n], t, o);
  return e;
}
function We(e, t, o, n) {
  return !e || !t || o <= 0 ? !1 : Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2) <= Math.pow(o + n, 2);
}
function Kt(e, { x: t, y: o, x2: n, y2: r }, i, { borderWidth: s, hitTolerance: a }) {
  const d = (s + a) / 2, l = e.x >= t - d - D && e.x <= n + d + D, c = e.y >= o - d - D && e.y <= r + d + D;
  return i === "x" ? l : (i === "y" || l) && c;
}
function Zt(e, { rect: t, center: o }, n, { rotation: r, borderWidth: i, hitTolerance: s }) {
  const a = Y(e, o, w(-r));
  return Kt(a, t, n, { borderWidth: i, hitTolerance: s });
}
function O(e, t) {
  const { centerX: o, centerY: n } = e.getProps(["centerX", "centerY"], t);
  return { x: o, y: n };
}
function Ie(e, t, o, n = !0) {
  const r = o.split(".");
  let i = 0;
  for (const s of t.split(".")) {
    const a = r[i++];
    if (parseInt(s, 10) < parseInt(a, 10))
      break;
    if (Oe(a, s)) {
      if (n)
        throw new Error(`${e} v${o} is not supported. v${t} or newer is required.`);
      return !1;
    }
  }
  return !0;
}
const te = (e) => typeof e == "string" && e.endsWith("%"), ee = (e) => parseFloat(e) / 100, oe = (e) => K(ee(e), 0, 1), H = (e, t) => ({ x: e, y: t, x2: e, y2: t, width: 0, height: 0 }), Re = {
  box: (e) => H(e.centerX, e.centerY),
  doughnutLabel: (e) => H(e.centerX, e.centerY),
  ellipse: (e) => ({ centerX: e.centerX, centerY: e.centerX, radius: 0, width: 0, height: 0 }),
  label: (e) => H(e.centerX, e.centerY),
  line: (e) => H(e.x, e.y),
  point: (e) => ({ centerX: e.centerX, centerY: e.centerY, radius: 0, width: 0, height: 0 }),
  polygon: (e) => H(e.centerX, e.centerY)
};
function mt(e, t) {
  return t === "start" ? 0 : t === "end" ? e : te(t) ? oe(t) * e : e / 2;
}
function k(e, t, o = !0) {
  return typeof t == "number" ? t : te(t) ? (o ? oe(t) : ee(t)) * e : e;
}
function _e(e, t) {
  const { x: o, width: n } = e, r = t.textAlign;
  return r === "center" ? o + n / 2 : r === "end" || r === "right" ? o + n : o;
}
function ne(e, t, { borderWidth: o, position: n, xAdjust: r, yAdjust: i }, s) {
  const a = I(s), d = t.width + (a ? s.width : 0) + o, l = t.height + (a ? s.height : 0) + o, c = vt(n), h = At(e.x, d, r, c.x), u = At(e.y, l, i, c.y);
  return {
    x: h,
    y: u,
    x2: h + d,
    y2: u + l,
    width: d,
    height: l,
    centerX: h + d / 2,
    centerY: u + l / 2
  };
}
function vt(e, t = "center") {
  return I(e) ? {
    x: L(e.x, t),
    y: L(e.y, t)
  } : (e = L(e, t), {
    x: e,
    y: e
  });
}
const re = (e, t) => e && e.autoFit && t < 1;
function ie(e, t) {
  const o = e.font, n = W(o) ? o : [o];
  return re(e, t) ? n.map(function(r) {
    const i = at(r);
    return i.size = Math.floor(r.size * t), i.lineHeight = r.lineHeight, at(i);
  }) : n.map((r) => at(r));
}
function se(e) {
  return e && (m(e.xValue) || m(e.yValue));
}
function At(e, t, o = 0, n) {
  return e - mt(t, n) + o;
}
function _(e, t, o) {
  const n = o.init;
  if (n) {
    if (n === !0)
      return de(t, o);
  } else return;
  return Ee(e, t, o);
}
function ae(e, t, o) {
  let n = !1;
  return t.forEach((r) => {
    X(e[r]) ? (n = !0, o[r] = e[r]) : m(o[r]) && delete o[r];
  }), n;
}
function de(e, t) {
  const o = t.type || "line";
  return Re[o](e);
}
function Ee(e, t, o) {
  const n = pt(o.init, [{ chart: e, properties: t, options: o }]);
  if (n === !0)
    return de(t, o);
  if (I(n))
    return n;
}
const dt = /* @__PURE__ */ new Map(), $e = (e) => isNaN(e) || e <= 0, ze = (e) => e.reduce(function(t, o) {
  return t += o.string, t;
}, "");
function Z(e) {
  if (e && typeof e == "object") {
    const t = e.toString();
    return t === "[object HTMLImageElement]" || t === "[object HTMLCanvasElement]";
  }
}
function tt(e, { x: t, y: o }, n) {
  n && (e.translate(t, o), e.rotate(w(n)), e.translate(-t, -o));
}
function v(e, t) {
  if (t && t.borderWidth)
    return e.lineCap = t.borderCapStyle || "butt", e.setLineDash(t.borderDash), e.lineDashOffset = t.borderDashOffset, e.lineJoin = t.borderJoinStyle || "miter", e.lineWidth = t.borderWidth, e.strokeStyle = t.borderColor, !0;
}
function E(e, t) {
  e.shadowColor = t.backgroundShadowColor, e.shadowBlur = t.shadowBlur, e.shadowOffsetX = t.shadowOffsetX, e.shadowOffsetY = t.shadowOffsetY;
}
function et(e, t) {
  const o = t.content;
  if (Z(o))
    return {
      width: k(o.width, t.width),
      height: k(o.height, t.height)
    };
  const n = ie(t), r = t.textStrokeWidth, i = W(o) ? o : [o], s = i.join() + ze(n) + r + (e._measureText ? "-spriting" : "");
  return dt.has(s) || dt.set(s, Le(e, i, n, r)), dt.get(s);
}
function le(e, t, o) {
  const { x: n, y: r, width: i, height: s } = t;
  e.save(), E(e, o);
  const a = v(e, o);
  e.fillStyle = o.backgroundColor, e.beginPath(), Ce(e, {
    x: n,
    y: r,
    w: i,
    h: s,
    radius: Xe(ke(o.borderRadius), 0, Math.min(i, s) / 2)
  }), e.closePath(), e.fill(), a && (e.shadowColor = o.borderShadowColor, e.stroke()), e.restore();
}
function ce(e, t, o, n) {
  const r = o.content;
  if (Z(r)) {
    e.save(), e.globalAlpha = Je(o.opacity, r.style.opacity), e.drawImage(r, t.x, t.y, t.width, t.height), e.restore();
    return;
  }
  const i = W(r) ? r : [r], s = ie(o, n), a = o.color, d = W(a) ? a : [a], l = _e(t, o), c = t.y + o.textStrokeWidth / 2;
  e.save(), e.textBaseline = "middle", e.textAlign = o.textAlign, He(e, o) && Be(e, { x: l, y: c }, i, s), Fe(e, { x: l, y: c }, i, { fonts: s, colors: d }), e.restore();
}
function He(e, t) {
  if (t.textStrokeWidth > 0)
    return e.lineJoin = "round", e.miterLimit = 2, e.lineWidth = t.textStrokeWidth, e.strokeStyle = t.textStrokeColor, !0;
}
function Ne(e, t, o, n) {
  const { radius: r, options: i } = t, s = i.pointStyle, a = i.rotation;
  let d = (a || 0) * qt;
  if (Z(s)) {
    e.save(), e.translate(o, n), e.rotate(d), e.drawImage(s, -s.width / 2, -s.height / 2, s.width, s.height), e.restore();
    return;
  }
  $e(r) || Ve(e, { x: o, y: n, radius: r, rotation: a, style: s, rad: d });
}
function Ve(e, { x: t, y: o, radius: n, rotation: r, style: i, rad: s }) {
  let a, d, l, c;
  switch (e.beginPath(), i) {
    // Default includes circle
    default:
      e.arc(t, o, n, 0, Gt), e.closePath();
      break;
    case "triangle":
      e.moveTo(t + Math.sin(s) * n, o - Math.cos(s) * n), s += Pt, e.lineTo(t + Math.sin(s) * n, o - Math.cos(s) * n), s += Pt, e.lineTo(t + Math.sin(s) * n, o - Math.cos(s) * n), e.closePath();
      break;
    case "rectRounded":
      c = n * 0.516, l = n - c, a = Math.cos(s + z) * l, d = Math.sin(s + z) * l, e.arc(t - a, o - d, c, s - b, s - q), e.arc(t + d, o - a, c, s - q, s), e.arc(t + a, o + d, c, s, s + q), e.arc(t - d, o + a, c, s + q, s + b), e.closePath();
      break;
    case "rect":
      if (!r) {
        l = Math.SQRT1_2 * n, e.rect(t - l, o - l, 2 * l, 2 * l);
        break;
      }
      s += z;
    /* falls through */
    case "rectRot":
      a = Math.cos(s) * n, d = Math.sin(s) * n, e.moveTo(t - a, o - d), e.lineTo(t + d, o - a), e.lineTo(t + a, o + d), e.lineTo(t - d, o + a), e.closePath();
      break;
    case "crossRot":
      s += z;
    /* falls through */
    case "cross":
      a = Math.cos(s) * n, d = Math.sin(s) * n, e.moveTo(t - a, o - d), e.lineTo(t + a, o + d), e.moveTo(t + d, o - a), e.lineTo(t - d, o + a);
      break;
    case "star":
      a = Math.cos(s) * n, d = Math.sin(s) * n, e.moveTo(t - a, o - d), e.lineTo(t + a, o + d), e.moveTo(t + d, o - a), e.lineTo(t - d, o + a), s += z, a = Math.cos(s) * n, d = Math.sin(s) * n, e.moveTo(t - a, o - d), e.lineTo(t + a, o + d), e.moveTo(t + d, o - a), e.lineTo(t - d, o + a);
      break;
    case "line":
      a = Math.cos(s) * n, d = Math.sin(s) * n, e.moveTo(t - a, o - d), e.lineTo(t + a, o + d);
      break;
    case "dash":
      e.moveTo(t, o), e.lineTo(t + Math.cos(s) * n, o + Math.sin(s) * n);
      break;
  }
  e.fill();
}
function Le(e, t, o, n) {
  e.save();
  const r = t.length;
  let i = 0, s = n;
  for (let a = 0; a < r; a++) {
    const d = o[Math.min(a, o.length - 1)];
    e.font = d.string;
    const l = t[a];
    i = Math.max(i, e.measureText(l).width + n), s += d.lineHeight;
  }
  return e.restore(), { width: i, height: s };
}
function Be(e, { x: t, y: o }, n, r) {
  e.beginPath();
  let i = 0;
  n.forEach(function(s, a) {
    const d = r[Math.min(a, r.length - 1)], l = d.lineHeight;
    e.font = d.string, e.strokeText(s, t, o + l / 2 + i), i += l;
  }), e.stroke();
}
function Fe(e, { x: t, y: o }, n, { fonts: r, colors: i }) {
  let s = 0;
  n.forEach(function(a, d) {
    const l = i[Math.min(d, i.length - 1)], c = r[Math.min(d, r.length - 1)], h = c.lineHeight;
    e.beginPath(), e.font = c.string, e.fillStyle = l, e.fillText(a, t, o + h / 2 + s), s += h, e.fill();
  });
}
function Je(e, t) {
  const o = kt(e) ? e : t;
  return kt(o) ? K(o, 0, 1) : 1;
}
const he = ["left", "bottom", "top", "right"];
function qe(e, t) {
  const { pointX: o, pointY: n, options: r } = t, i = r.callout, s = i && i.display && Ze(t, i);
  if (!s || eo(t, i, s))
    return;
  if (e.save(), e.beginPath(), !v(e, i))
    return e.restore();
  const { separatorStart: a, separatorEnd: d } = Ue(t, s), { sideStart: l, sideEnd: c } = Qe(t, s, a);
  (i.margin > 0 || r.borderWidth === 0) && (e.moveTo(a.x, a.y), e.lineTo(d.x, d.y)), e.moveTo(l.x, l.y), e.lineTo(c.x, c.y);
  const h = Y({ x: o, y: n }, t.getCenterPoint(), w(-t.rotation));
  e.lineTo(h.x, h.y), e.stroke(), e.restore();
}
function Ue(e, t) {
  const { x: o, y: n, x2: r, y2: i } = e, s = Ge(e, t);
  let a, d;
  return t === "left" || t === "right" ? (a = { x: o + s, y: n }, d = { x: a.x, y: i }) : (a = { x: o, y: n + s }, d = { x: r, y: a.y }), { separatorStart: a, separatorEnd: d };
}
function Ge(e, t) {
  const { width: o, height: n, options: r } = e, i = r.callout.margin + r.borderWidth / 2;
  return t === "right" ? o + i : t === "bottom" ? n + i : -i;
}
function Qe(e, t, o) {
  const { y: n, width: r, height: i, options: s } = e, a = s.callout.start, d = Ke(t, s.callout);
  let l, c;
  return t === "left" || t === "right" ? (l = { x: o.x, y: n + k(i, a) }, c = { x: l.x + d, y: l.y }) : (l = { x: o.x + k(r, a), y: o.y }, c = { x: l.x, y: l.y + d }), { sideStart: l, sideEnd: c };
}
function Ke(e, t) {
  const o = t.side;
  return e === "left" || e === "top" ? -o : o;
}
function Ze(e, t) {
  const o = t.position;
  return he.includes(o) ? o : to(e, t);
}
function to(e, t) {
  const { x: o, y: n, x2: r, y2: i, width: s, height: a, pointX: d, pointY: l, centerX: c, centerY: h, rotation: u } = e, f = { x: c, y: h }, x = t.start, g = k(s, x), M = k(a, x), y = [o, o + g, o + g, r], p = [n + M, i, n, i], P = [];
  for (let T = 0; T < 4; T++) {
    const it = Y({ x: y[T], y: p[T] }, f, w(u));
    P.push({
      position: he[T],
      distance: bt(it, { x: d, y: l })
    });
  }
  return P.sort((T, it) => T.distance - it.distance)[0].position;
}
function eo(e, t, o) {
  const { pointX: n, pointY: r } = e, i = t.margin;
  let s = n, a = r;
  return o === "left" ? s += i : o === "right" ? s -= i : o === "top" ? a += i : o === "bottom" && (a -= i), e.inRange(s, a);
}
const jt = {
  xScaleID: { min: "xMin", max: "xMax", start: "left", end: "right", startProp: "x", endProp: "x2" },
  yScaleID: { min: "yMin", max: "yMax", start: "bottom", end: "top", startProp: "y", endProp: "y2" }
};
function R(e, t, o) {
  return t = typeof t == "number" ? t : e.parse(t), Ut(t) ? e.getPixelForValue(t) : o;
}
function A(e, t, o) {
  const n = t[o];
  if (n || o === "scaleID")
    return n;
  const r = o.charAt(0), i = Object.values(e).filter((s) => s.axis && s.axis === r);
  return i.length ? i[0].id : r;
}
function ue(e, t) {
  if (e) {
    const o = e.options.reverse, n = R(e, t.min, o ? t.end : t.start), r = R(e, t.max, o ? t.start : t.end);
    return {
      start: n,
      end: r
    };
  }
}
function fe(e, t) {
  const { chartArea: o, scales: n } = e, r = n[A(n, t, "xScaleID")], i = n[A(n, t, "yScaleID")];
  let s = o.width / 2, a = o.height / 2;
  return r && (s = R(r, t.xValue, r.left + r.width / 2)), i && (a = R(i, t.yValue, i.top + i.height / 2)), { x: s, y: a };
}
function wt(e, t) {
  const o = e.scales, n = o[A(o, t, "xScaleID")], r = o[A(o, t, "yScaleID")];
  if (!n && !r)
    return {};
  let { left: i, right: s } = n || e.chartArea, { top: a, bottom: d } = r || e.chartArea;
  const l = Yt(n, { min: t.xMin, max: t.xMax, start: i, end: s });
  i = l.start, s = l.end;
  const c = Yt(r, { min: t.yMin, max: t.yMax, start: d, end: a });
  return a = c.start, d = c.end, {
    x: i,
    y: a,
    x2: s,
    y2: d,
    width: s - i,
    height: d - a,
    centerX: i + (s - i) / 2,
    centerY: a + (d - a) / 2
  };
}
function xe(e, t) {
  if (!se(t)) {
    const o = wt(e, t);
    let n = t.radius;
    (!n || isNaN(n)) && (n = Math.min(o.width, o.height) / 2, t.radius = n);
    const r = n * 2, i = o.centerX + t.xAdjust, s = o.centerY + t.yAdjust;
    return {
      x: i - n,
      y: s - n,
      x2: i + n,
      y2: s + n,
      centerX: i,
      centerY: s,
      width: r,
      height: r,
      radius: n
    };
  }
  return no(e, t);
}
function oo(e, t) {
  const { scales: o, chartArea: n } = e, r = o[t.scaleID], i = { x: n.left, y: n.top, x2: n.right, y2: n.bottom };
  return r ? ro(r, i, t) : io(o, i, t), i;
}
function ye(e, t) {
  const o = wt(e, t);
  return o.initProperties = _(e, o, t), o.elements = [{
    type: "label",
    optionScope: "label",
    properties: lo(e, o, t),
    initProperties: o.initProperties
  }], o;
}
function no(e, t) {
  const o = fe(e, t), n = t.radius * 2;
  return {
    x: o.x - t.radius + t.xAdjust,
    y: o.y - t.radius + t.yAdjust,
    x2: o.x + t.radius + t.xAdjust,
    y2: o.y + t.radius + t.yAdjust,
    centerX: o.x + t.xAdjust,
    centerY: o.y + t.yAdjust,
    radius: t.radius,
    width: n,
    height: n
  };
}
function Yt(e, t) {
  const o = ue(e, t) || t;
  return {
    start: Math.min(o.start, o.end),
    end: Math.max(o.start, o.end)
  };
}
function ro(e, t, o) {
  const n = R(e, o.value, NaN), r = R(e, o.endValue, n);
  e.isHorizontal() ? (t.x = n, t.x2 = r) : (t.y = n, t.y2 = r);
}
function io(e, t, o) {
  for (const n of Object.keys(jt)) {
    const r = e[A(e, o, n)];
    if (r) {
      const { min: i, max: s, start: a, end: d, startProp: l, endProp: c } = jt[n], h = ue(r, { min: o[i], max: o[s], start: r[a], end: r[d] });
      t[l] = h.start, t[c] = h.end;
    }
  }
}
function so({ properties: e, options: t }, o, n, r) {
  const { x: i, x2: s, width: a } = e;
  return pe({ start: i, end: s, borderWidth: t.borderWidth }, {
    position: n.x,
    padding: { start: r.left, end: r.right },
    adjust: t.label.xAdjust,
    size: o.width
  });
}
function ao({ properties: e, options: t }, o, n, r) {
  const { y: i, y2: s, height: a } = e;
  return pe({ start: i, end: s, borderWidth: t.borderWidth }, {
    position: n.y,
    padding: { start: r.top, end: r.bottom },
    adjust: t.label.yAdjust,
    size: o.height
  });
}
function pe(e, t) {
  const { start: o, end: n, borderWidth: r } = e, { position: i, padding: { start: s, end: a }, adjust: d } = t, l = n - r - o - s - a - t.size;
  return o + r / 2 + d + mt(l, i);
}
function lo(e, t, o) {
  const n = o.label;
  n.backgroundColor = "transparent", n.callout.display = !1;
  const r = vt(n.position), i = Q(n.padding), s = et(e.ctx, n), a = so({ properties: t, options: o }, s, r, i), d = ao({ properties: t, options: o }, s, r, i), l = s.width + i.width, c = s.height + i.height;
  return {
    x: a,
    y: d,
    x2: a + l,
    y2: d + c,
    width: l,
    height: c,
    centerX: a + l / 2,
    centerY: d + c / 2,
    rotation: n.rotation
  };
}
const lt = ["enter", "leave"], Mt = lt.concat("click");
function co(e, t, o) {
  t.listened = ae(o, Mt, t.listeners), t.moveListened = !1, lt.forEach((n) => {
    X(o[n]) && (t.moveListened = !0);
  }), (!t.listened || !t.moveListened) && t.annotations.forEach((n) => {
    !t.listened && X(n.click) && (t.listened = !0), t.moveListened || lt.forEach((r) => {
      X(n[r]) && (t.listened = !0, t.moveListened = !0);
    });
  });
}
function ho(e, t, o) {
  if (e.listened)
    switch (t.type) {
      case "mousemove":
      case "mouseout":
        return uo(e, t, o);
      case "click":
        return fo(e, t, o);
    }
}
function uo(e, t, o) {
  if (!e.moveListened)
    return;
  let n;
  t.type === "mousemove" ? n = gt(e.visibleElements, t, o.interaction) : n = [];
  const r = e.hovered;
  e.hovered = n;
  const i = { state: e, event: t };
  let s = Ot(i, "leave", r, n);
  return Ot(i, "enter", n, r) || s;
}
function Ot({ state: e, event: t }, o, n, r) {
  let i;
  for (const s of n)
    r.indexOf(s) < 0 && (i = be(s.options[o] || e.listeners[o], s, t) || i);
  return i;
}
function fo(e, t, o) {
  const n = e.listeners, r = gt(e.visibleElements, t, o.interaction);
  let i;
  for (const s of r)
    i = be(s.options.click || n.click, s, t) || i;
  return i;
}
function be(e, t, o) {
  return pt(e, [t.$context, o]) === !0;
}
const G = ["afterDraw", "beforeDraw"];
function xo(e, t, o) {
  const n = t.visibleElements;
  t.hooked = ae(o, G, t.hooks), t.hooked || n.forEach((r) => {
    t.hooked || G.forEach((i) => {
      X(r.options[i]) && (t.hooked = !0);
    });
  });
}
function Xt(e, t, o) {
  if (e.hooked) {
    const n = t.options[o] || e.hooks[o];
    return pt(n, [t.$context]);
  }
}
function yo(e, t, o) {
  const n = vo(e.scales, t, o);
  let r = Wt(t, n, "min", "suggestedMin");
  r = Wt(t, n, "max", "suggestedMax") || r, r && X(t.handleTickRangeOptions) && t.handleTickRangeOptions();
}
function po(e, t) {
  for (const o of e)
    go(o, t);
}
function Wt(e, t, o, n) {
  if (Ut(t[o]) && !bo(e.options, o, n)) {
    const r = e[o] !== t[o];
    return e[o] = t[o], r;
  }
}
function bo(e, t, o) {
  return m(e[t]) || m(e[o]);
}
function go(e, t) {
  for (const o of ["scaleID", "xScaleID", "yScaleID"]) {
    const n = A(t, e, o);
    n && !t[n] && mo(e, o) && console.warn(`No scale found with id '${n}' for annotation '${e.id}'`);
  }
}
function mo(e, t) {
  if (t === "scaleID")
    return !0;
  const o = t.charAt(0);
  for (const n of ["Min", "Max", "Value"])
    if (m(e[o + n]))
      return !0;
  return !1;
}
function vo(e, t, o) {
  const n = t.axis, r = t.id, i = n + "ScaleID", s = {
    min: L(t.min, Number.NEGATIVE_INFINITY),
    max: L(t.max, Number.POSITIVE_INFINITY)
  };
  for (const a of o)
    a.scaleID === r ? It(a, t, ["value", "endValue"], s) : A(e, a, i) === r && It(a, t, [n + "Min", n + "Max", n + "Value"], s);
  return s;
}
function It(e, t, o, n) {
  for (const r of o) {
    const i = e[r];
    if (m(i)) {
      const s = t.parse(i);
      n.min = Math.min(n.min, s), n.max = Math.max(n.max, s);
    }
  }
}
class $ extends j {
  inRange(t, o, n, r) {
    const { x: i, y: s } = Y({ x: t, y: o }, this.getCenterPoint(r), w(-this.options.rotation));
    return Kt({ x: i, y: s }, this.getProps(["x", "y", "x2", "y2"], r), n, this.options);
  }
  getCenterPoint(t) {
    return O(this, t);
  }
  draw(t) {
    t.save(), tt(t, this.getCenterPoint(), this.options.rotation), le(t, this, this.options), t.restore();
  }
  get label() {
    return this.elements && this.elements[0];
  }
  resolveElementProperties(t, o) {
    return ye(t, o);
  }
}
$.id = "boxAnnotation";
$.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderRadius: 0,
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  init: void 0,
  hitTolerance: 0,
  label: {
    backgroundColor: "transparent",
    borderWidth: 0,
    callout: {
      display: !1
    },
    color: "black",
    content: null,
    display: !1,
    drawTime: void 0,
    font: {
      family: void 0,
      lineHeight: void 0,
      size: void 0,
      style: void 0,
      weight: "bold"
    },
    height: void 0,
    hitTolerance: void 0,
    opacity: void 0,
    padding: 6,
    position: "center",
    rotation: void 0,
    textAlign: "start",
    textStrokeColor: void 0,
    textStrokeWidth: 0,
    width: void 0,
    xAdjust: 0,
    yAdjust: 0,
    z: void 0
  },
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  z: 0
};
$.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
$.descriptors = {
  label: {
    _fallback: !0
  }
};
class ot extends j {
  inRange(t, o, n, r) {
    return Zt(
      { x: t, y: o },
      { rect: this.getProps(["x", "y", "x2", "y2"], r), center: this.getCenterPoint(r) },
      n,
      { rotation: this.rotation, borderWidth: 0, hitTolerance: this.options.hitTolerance }
    );
  }
  getCenterPoint(t) {
    return O(this, t);
  }
  draw(t) {
    const o = this.options;
    !o.display || !o.content || (Po(t, this), t.save(), tt(t, this.getCenterPoint(), this.rotation), ce(t, this, o, this._fitRatio), t.restore());
  }
  resolveElementProperties(t, o) {
    const n = wo(t, o);
    if (!n)
      return {};
    const { controllerMeta: r, point: i, radius: s } = So(t, o, n);
    let a = et(t.ctx, o);
    const d = Co(a, s);
    re(o, d) && (a = { width: a.width * d, height: a.height * d });
    const { position: l, xAdjust: c, yAdjust: h } = o, u = ne(i, a, { borderWidth: 0, position: l, xAdjust: c, yAdjust: h });
    return {
      initProperties: _(t, u, o),
      ...u,
      ...r,
      rotation: o.rotation,
      _fitRatio: d
    };
  }
}
ot.id = "doughnutLabelAnnotation";
ot.defaults = {
  autoFit: !0,
  autoHide: !0,
  backgroundColor: "transparent",
  backgroundShadowColor: "transparent",
  borderColor: "transparent",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderShadowColor: "transparent",
  borderWidth: 0,
  color: "black",
  content: null,
  display: !0,
  font: {
    family: void 0,
    lineHeight: void 0,
    size: void 0,
    style: void 0,
    weight: void 0
  },
  height: void 0,
  hitTolerance: 0,
  init: void 0,
  opacity: void 0,
  position: "center",
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  spacing: 1,
  textAlign: "center",
  textStrokeColor: void 0,
  textStrokeWidth: 0,
  width: void 0,
  xAdjust: 0,
  yAdjust: 0
};
ot.defaultRoutes = {};
function wo(e, t) {
  return e.getSortedVisibleDatasetMetas().reduce(function(o, n) {
    const r = n.controller;
    return r instanceof we && Mo(e, t, n.data) && (!o || r.innerRadius < o.controller.innerRadius) && r.options.circumference >= 90 ? n : o;
  }, void 0);
}
function Mo(e, t, o) {
  if (!t.autoHide)
    return !0;
  for (let n = 0; n < o.length; n++)
    if (!o[n].hidden && e.getDataVisibility(n))
      return !0;
}
function So({ chartArea: e }, t, o) {
  const { left: n, top: r, right: i, bottom: s } = e, { innerRadius: a, offsetX: d, offsetY: l } = o.controller, c = (n + i) / 2 + d, h = (r + s) / 2 + l, u = {
    left: Math.max(c - a, n),
    right: Math.min(c + a, i),
    top: Math.max(h - a, r),
    bottom: Math.min(h + a, s)
  }, f = {
    x: (u.left + u.right) / 2,
    y: (u.top + u.bottom) / 2
  }, x = t.spacing + t.borderWidth / 2, g = a - x, M = f.y > h, y = M ? r + x : s - x, p = ko(y, c, h, g);
  return {
    controllerMeta: {
      _centerX: c,
      _centerY: h,
      _radius: g,
      _counterclockwise: M,
      ...p
    },
    point: f,
    radius: Math.min(a, Math.min(u.right - u.left, u.bottom - u.top) / 2)
  };
}
function Co({ width: e, height: t }, o) {
  const n = Math.sqrt(Math.pow(e, 2) + Math.pow(t, 2));
  return o * 2 / n;
}
function ko(e, t, o, n) {
  const r = Math.pow(o - e, 2), i = Math.pow(n, 2), s = t * -2, a = Math.pow(t, 2) + r - i, d = Math.pow(s, 2) - 4 * a;
  if (d <= 0)
    return {
      _startAngle: 0,
      _endAngle: Gt
    };
  const l = (-s - Math.sqrt(d)) / 2, c = (-s + Math.sqrt(d)) / 2;
  return {
    _startAngle: Tt({ x: t, y: o }, { x: l, y: e }).angle,
    _endAngle: Tt({ x: t, y: o }, { x: c, y: e }).angle
  };
}
function Po(e, t) {
  const { _centerX: o, _centerY: n, _radius: r, _startAngle: i, _endAngle: s, _counterclockwise: a, options: d } = t;
  e.save();
  const l = v(e, d);
  e.fillStyle = d.backgroundColor, e.beginPath(), e.arc(o, n, r, i, s, a), e.closePath(), e.fill(), l && e.stroke(), e.restore();
}
class B extends j {
  inRange(t, o, n, r) {
    return Zt(
      { x: t, y: o },
      { rect: this.getProps(["x", "y", "x2", "y2"], r), center: this.getCenterPoint(r) },
      n,
      { rotation: this.rotation, borderWidth: this.options.borderWidth, hitTolerance: this.options.hitTolerance }
    );
  }
  getCenterPoint(t) {
    return O(this, t);
  }
  draw(t) {
    const o = this.options, n = !m(this._visible) || this._visible;
    !o.display || !o.content || !n || (t.save(), tt(t, this.getCenterPoint(), this.rotation), qe(t, this), le(t, this, o), ce(t, To(this), o), t.restore());
  }
  resolveElementProperties(t, o) {
    let n;
    if (se(o))
      n = fe(t, o);
    else {
      const { centerX: a, centerY: d } = wt(t, o);
      n = { x: a, y: d };
    }
    const r = Q(o.padding), i = et(t.ctx, o), s = ne(n, i, o, r);
    return {
      initProperties: _(t, s, o),
      pointX: n.x,
      pointY: n.y,
      ...s,
      rotation: o.rotation
    };
  }
}
B.id = "labelAnnotation";
B.defaults = {
  adjustScaleRange: !0,
  backgroundColor: "transparent",
  backgroundShadowColor: "transparent",
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderRadius: 0,
  borderShadowColor: "transparent",
  borderWidth: 0,
  callout: {
    borderCapStyle: "butt",
    borderColor: void 0,
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderWidth: 1,
    display: !1,
    margin: 5,
    position: "auto",
    side: 5,
    start: "50%"
  },
  color: "black",
  content: null,
  display: !0,
  font: {
    family: void 0,
    lineHeight: void 0,
    size: void 0,
    style: void 0,
    weight: void 0
  },
  height: void 0,
  hitTolerance: 0,
  init: void 0,
  opacity: void 0,
  padding: 6,
  position: "center",
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  textAlign: "center",
  textStrokeColor: void 0,
  textStrokeWidth: 0,
  width: void 0,
  xAdjust: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  xValue: void 0,
  yAdjust: 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  yValue: void 0,
  z: 0
};
B.defaultRoutes = {
  borderColor: "color"
};
function To({ x: e, y: t, width: o, height: n, options: r }) {
  const i = r.borderWidth / 2, s = Q(r.padding);
  return {
    x: e + s.left + i,
    y: t + s.top + i,
    width: o - s.left - s.right - r.borderWidth,
    height: n - s.top - s.bottom - r.borderWidth
  };
}
const St = (e, t, o) => ({ x: e.x + o * (t.x - e.x), y: e.y + o * (t.y - e.y) }), ct = (e, t, o) => St(t, o, Math.abs((e - t.y) / (o.y - t.y))).x, Rt = (e, t, o) => St(t, o, Math.abs((e - t.x) / (o.x - t.x))).y, V = (e) => e * e, Do = (e, t, { x: o, y: n, x2: r, y2: i }, s) => s === "y" ? { start: Math.min(n, i), end: Math.max(n, i), value: t } : { start: Math.min(o, r), end: Math.max(o, r), value: e }, _t = (e, t, o, n) => (1 - n) * (1 - n) * e + 2 * (1 - n) * n * t + n * n * o, ht = (e, t, o, n) => ({ x: _t(e.x, t.x, o.x, n), y: _t(e.y, t.y, o.y, n) }), Et = (e, t, o, n) => 2 * (1 - n) * (t - e) + 2 * n * (o - t), $t = (e, t, o, n) => -Math.atan2(Et(e.x, t.x, o.x, n), Et(e.y, t.y, o.y, n)) + 0.5 * b;
class F extends j {
  inRange(t, o, n, r) {
    const i = (this.options.borderWidth + this.options.hitTolerance) / 2;
    if (n !== "x" && n !== "y") {
      const s = { mouseX: t, mouseY: o }, { path: a, ctx: d } = this;
      if (a) {
        v(d, this.options), d.lineWidth += this.options.hitTolerance;
        const { chart: c } = this.$context, h = t * c.currentDevicePixelRatio, u = o * c.currentDevicePixelRatio, f = d.isPointInStroke(a, h, u) || ut(this, s, r);
        return d.restore(), f;
      }
      const l = V(i);
      return Oo(this, s, l, r) || ut(this, s, r);
    }
    return Ao(this, { mouseX: t, mouseY: o }, n, { hitSize: i, useFinalPosition: r });
  }
  getCenterPoint(t) {
    return O(this, t);
  }
  draw(t) {
    const { x: o, y: n, x2: r, y2: i, cp: s, options: a } = this;
    if (t.save(), !v(t, a))
      return t.restore();
    E(t, a);
    const d = Math.sqrt(Math.pow(r - o, 2) + Math.pow(i - n, 2));
    if (a.curve && s)
      return zo(t, this, s, d), t.restore();
    const { startOpts: l, endOpts: c, startAdjust: h, endAdjust: u } = ge(this), f = Math.atan2(i - n, r - o);
    t.translate(o, n), t.rotate(f), t.beginPath(), t.moveTo(0 + h, 0), t.lineTo(d - u, 0), t.shadowColor = a.borderShadowColor, t.stroke(), ft(t, 0, h, l), ft(t, d, -u, c), t.restore();
  }
  get label() {
    return this.elements && this.elements[0];
  }
  resolveElementProperties(t, o) {
    const n = oo(t, o), { x: r, y: i, x2: s, y2: a } = n, d = jo(n, t.chartArea), l = d ? Yo({ x: r, y: i }, { x: s, y: a }, t.chartArea) : { x: r, y: i, x2: s, y2: a, width: Math.abs(s - r), height: Math.abs(a - i) };
    if (l.centerX = (s + r) / 2, l.centerY = (a + i) / 2, l.initProperties = _(t, l, o), o.curve) {
      const h = { x: l.x, y: l.y }, u = { x: l.x2, y: l.y2 };
      l.cp = $o(l, o, bt(h, u));
    }
    const c = Xo(t, l, o.label);
    return c._visible = d, l.elements = [{
      type: "label",
      optionScope: "label",
      properties: c,
      initProperties: l.initProperties
    }], l;
  }
}
F.id = "lineAnnotation";
const zt = {
  backgroundColor: void 0,
  backgroundShadowColor: void 0,
  borderColor: void 0,
  borderDash: void 0,
  borderDashOffset: void 0,
  borderShadowColor: void 0,
  borderWidth: void 0,
  display: void 0,
  fill: void 0,
  length: void 0,
  shadowBlur: void 0,
  shadowOffsetX: void 0,
  shadowOffsetY: void 0,
  width: void 0
};
F.defaults = {
  adjustScaleRange: !0,
  arrowHeads: {
    display: !1,
    end: Object.assign({}, zt),
    fill: !1,
    length: 12,
    start: Object.assign({}, zt),
    width: 6
  },
  borderDash: [],
  borderDashOffset: 0,
  borderShadowColor: "transparent",
  borderWidth: 2,
  curve: !1,
  controlPoint: {
    y: "-50%"
  },
  display: !0,
  endValue: void 0,
  init: void 0,
  hitTolerance: 0,
  label: {
    backgroundColor: "rgba(0,0,0,0.8)",
    backgroundShadowColor: "transparent",
    borderCapStyle: "butt",
    borderColor: "black",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderRadius: 6,
    borderShadowColor: "transparent",
    borderWidth: 0,
    callout: Object.assign({}, B.defaults.callout),
    color: "#fff",
    content: null,
    display: !1,
    drawTime: void 0,
    font: {
      family: void 0,
      lineHeight: void 0,
      size: void 0,
      style: void 0,
      weight: "bold"
    },
    height: void 0,
    hitTolerance: void 0,
    opacity: void 0,
    padding: 6,
    position: "center",
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    textAlign: "center",
    textStrokeColor: void 0,
    textStrokeWidth: 0,
    width: void 0,
    xAdjust: 0,
    yAdjust: 0,
    z: void 0
  },
  scaleID: void 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  value: void 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  z: 0
};
F.descriptors = {
  arrowHeads: {
    start: {
      _fallback: !0
    },
    end: {
      _fallback: !0
    },
    _fallback: !0
  }
};
F.defaultRoutes = {
  borderColor: "color"
};
function Ao(e, { mouseX: t, mouseY: o }, n, { hitSize: r, useFinalPosition: i }) {
  const s = Do(t, o, e.getProps(["x", "y", "x2", "y2"], i), n);
  return Qt(s, r) || ut(e, { mouseX: t, mouseY: o }, i, n);
}
function jo({ x: e, y: t, x2: o, y2: n }, { top: r, right: i, bottom: s, left: a }) {
  return !(e < a && o < a || e > i && o > i || t < r && n < r || t > s && n > s);
}
function Ht({ x: e, y: t }, o, { top: n, right: r, bottom: i, left: s }) {
  return e < s && (t = Rt(s, { x: e, y: t }, o), e = s), e > r && (t = Rt(r, { x: e, y: t }, o), e = r), t < n && (e = ct(n, { x: e, y: t }, o), t = n), t > i && (e = ct(i, { x: e, y: t }, o), t = i), { x: e, y: t };
}
function Yo(e, t, o) {
  const { x: n, y: r } = Ht(e, t, o), { x: i, y: s } = Ht(t, e, o);
  return { x: n, y: r, x2: i, y2: s, width: Math.abs(i - n), height: Math.abs(s - r) };
}
function Oo(e, { mouseX: t, mouseY: o }, n = D, r) {
  const { x: i, y: s, x2: a, y2: d } = e.getProps(["x", "y", "x2", "y2"], r), l = a - i, c = d - s, h = V(l) + V(c), u = h === 0 ? -1 : ((t - i) * l + (o - s) * c) / h;
  let f, x;
  return u < 0 ? (f = i, x = s) : u > 1 ? (f = a, x = d) : (f = i + u * l, x = s + u * c), V(t - f) + V(o - x) <= n;
}
function ut(e, { mouseX: t, mouseY: o }, n, r) {
  const i = e.label;
  return i.options.display && i.inRange(t, o, r, n);
}
function Xo(e, t, o) {
  const n = o.borderWidth, r = Q(o.padding), i = et(e.ctx, o), s = i.width + r.width + n, a = i.height + r.height + n;
  return Io(t, o, { width: s, height: a, padding: r }, e.chartArea);
}
function Wo(e) {
  const { x: t, y: o, x2: n, y2: r } = e, i = Math.atan2(r - o, n - t);
  return i > b / 2 ? i - b : i < b / -2 ? i + b : i;
}
function Io(e, t, o, n) {
  const { width: r, height: i, padding: s } = o, { xAdjust: a, yAdjust: d } = t, l = { x: e.x, y: e.y }, c = { x: e.x2, y: e.y2 }, h = t.rotation === "auto" ? Wo(e) : w(t.rotation), u = Ro(r, i, h), f = _o(e, t, { labelSize: u, padding: s }, n), x = e.cp ? ht(l, e.cp, c, f) : St(l, c, f), g = { size: u.w, min: n.left, max: n.right, padding: s.left }, M = { size: u.h, min: n.top, max: n.bottom, padding: s.top }, y = Vt(x.x, g) + a, p = Vt(x.y, M) + d;
  return {
    x: y - r / 2,
    y: p - i / 2,
    x2: y + r / 2,
    y2: p + i / 2,
    centerX: y,
    centerY: p,
    pointX: x.x,
    pointY: x.y,
    width: r,
    height: i,
    rotation: Pe(h)
  };
}
function Ro(e, t, o) {
  const n = Math.cos(o), r = Math.sin(o);
  return {
    w: Math.abs(e * n) + Math.abs(t * r),
    h: Math.abs(e * r) + Math.abs(t * n)
  };
}
function _o(e, t, o, n) {
  let r;
  const i = Eo(e, n);
  return t.position === "start" ? r = Nt({ w: e.x2 - e.x, h: e.y2 - e.y }, o, t, i) : t.position === "end" ? r = 1 - Nt({ w: e.x - e.x2, h: e.y - e.y2 }, o, t, i) : r = mt(1, t.position), r;
}
function Nt(e, t, o, n) {
  const { labelSize: r, padding: i } = t, s = e.w * n.dx, a = e.h * n.dy, d = s > 0 && (r.w / 2 + i.left - n.x) / s, l = a > 0 && (r.h / 2 + i.top - n.y) / a;
  return K(Math.max(d, l), 0, 0.25);
}
function Eo(e, t) {
  const { x: o, x2: n, y: r, y2: i } = e, s = Math.min(r, i) - t.top, a = Math.min(o, n) - t.left, d = t.bottom - Math.max(r, i), l = t.right - Math.max(o, n);
  return {
    x: Math.min(a, l),
    y: Math.min(s, d),
    dx: a <= l ? 1 : -1,
    dy: s <= d ? 1 : -1
  };
}
function Vt(e, t) {
  const { size: o, min: n, max: r, padding: i } = t, s = o / 2;
  return o > r - n ? (r + n) / 2 : (n >= e - i - s && (e = n + i + s), r <= e + i + s && (e = r - i - s), e);
}
function ge(e) {
  const t = e.options, o = t.arrowHeads && t.arrowHeads.start, n = t.arrowHeads && t.arrowHeads.end;
  return {
    startOpts: o,
    endOpts: n,
    startAdjust: Lt(e, o),
    endAdjust: Lt(e, n)
  };
}
function Lt(e, t) {
  if (!t || !t.display)
    return 0;
  const { length: o, width: n } = t, r = e.options.borderWidth / 2, i = { x: o, y: n + r };
  return Math.abs(ct(0, i, { x: 0, y: r }));
}
function ft(e, t, o, n) {
  if (!n || !n.display)
    return;
  const { length: r, width: i, fill: s, backgroundColor: a, borderColor: d } = n, l = Math.abs(t - r) + o;
  e.beginPath(), E(e, n), v(e, n), e.moveTo(l, -i), e.lineTo(t + o, 0), e.lineTo(l, i), s === !0 ? (e.fillStyle = a || d, e.closePath(), e.fill(), e.shadowColor = "transparent") : e.shadowColor = n.borderShadowColor, e.stroke();
}
function $o(e, t, o) {
  const { x: n, y: r, x2: i, y2: s, centerX: a, centerY: d } = e, l = Math.atan2(s - r, i - n), c = vt(t.controlPoint, 0), h = {
    x: a + k(o, c.x, !1),
    y: d + k(o, c.y, !1)
  };
  return Y(h, { x: a, y: d }, l);
}
function Bt(e, { x: t, y: o }, { angle: n, adjust: r }, i) {
  !i || !i.display || (e.save(), e.translate(t, o), e.rotate(n), ft(e, 0, -r, i), e.restore());
}
function zo(e, t, o, n) {
  const { x: r, y: i, x2: s, y2: a, options: d } = t, { startOpts: l, endOpts: c, startAdjust: h, endAdjust: u } = ge(t), f = { x: r, y: i }, x = { x: s, y: a }, g = $t(f, o, x, 0), M = $t(f, o, x, 1) - b, y = ht(f, o, x, h / n), p = ht(f, o, x, 1 - u / n), P = new Path2D();
  e.beginPath(), P.moveTo(y.x, y.y), P.quadraticCurveTo(o.x, o.y, p.x, p.y), e.shadowColor = d.borderShadowColor, e.stroke(P), t.path = P, t.ctx = e, Bt(e, y, { angle: g, adjust: h }, l), Bt(e, p, { angle: M, adjust: u }, c);
}
class J extends j {
  inRange(t, o, n, r) {
    const i = this.options.rotation, s = (this.options.borderWidth + this.options.hitTolerance) / 2;
    if (n !== "x" && n !== "y")
      return Ho({ x: t, y: o }, this.getProps(["width", "height", "centerX", "centerY"], r), i, s);
    const { x: a, y: d, x2: l, y2: c } = this.getProps(["x", "y", "x2", "y2"], r), h = n === "y" ? { start: d, end: c } : { start: a, end: l }, u = Y({ x: t, y: o }, this.getCenterPoint(r), w(-i));
    return u[n] >= h.start - s - D && u[n] <= h.end + s + D;
  }
  getCenterPoint(t) {
    return O(this, t);
  }
  draw(t) {
    const { width: o, height: n, centerX: r, centerY: i, options: s } = this;
    t.save(), tt(t, this.getCenterPoint(), s.rotation), E(t, this.options), t.beginPath(), t.fillStyle = s.backgroundColor;
    const a = v(t, s);
    t.ellipse(r, i, n / 2, o / 2, b / 2, 0, 2 * b), t.fill(), a && (t.shadowColor = s.borderShadowColor, t.stroke()), t.restore();
  }
  get label() {
    return this.elements && this.elements[0];
  }
  resolveElementProperties(t, o) {
    return ye(t, o);
  }
}
J.id = "ellipseAnnotation";
J.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderDash: [],
  borderDashOffset: 0,
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  hitTolerance: 0,
  init: void 0,
  label: Object.assign({}, $.defaults.label),
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  z: 0
};
J.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
J.descriptors = {
  label: {
    _fallback: !0
  }
};
function Ho(e, t, o, n) {
  const { width: r, height: i, centerX: s, centerY: a } = t, d = r / 2, l = i / 2;
  if (d <= 0 || l <= 0)
    return !1;
  const c = w(o || 0), h = Math.cos(c), u = Math.sin(c), f = Math.pow(h * (e.x - s) + u * (e.y - a), 2), x = Math.pow(u * (e.x - s) - h * (e.y - a), 2);
  return f / Math.pow(d + n, 2) + x / Math.pow(l + n, 2) <= 1.0001;
}
class nt extends j {
  inRange(t, o, n, r) {
    const { x: i, y: s, x2: a, y2: d, width: l } = this.getProps(["x", "y", "x2", "y2", "width"], r), c = (this.options.borderWidth + this.options.hitTolerance) / 2;
    return n !== "x" && n !== "y" ? We({ x: t, y: o }, this.getCenterPoint(r), l / 2, c) : Qt(n === "y" ? { start: s, end: d, value: o } : { start: i, end: a, value: t }, c);
  }
  getCenterPoint(t) {
    return O(this, t);
  }
  draw(t) {
    const o = this.options, n = o.borderWidth;
    if (o.radius < 0.1)
      return;
    t.save(), t.fillStyle = o.backgroundColor, E(t, o);
    const r = v(t, o);
    Ne(t, this, this.centerX, this.centerY), r && !Z(o.pointStyle) && (t.shadowColor = o.borderShadowColor, t.stroke()), t.restore(), o.borderWidth = n;
  }
  resolveElementProperties(t, o) {
    const n = xe(t, o);
    return n.initProperties = _(t, n, o), n;
  }
}
nt.id = "pointAnnotation";
nt.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderDash: [],
  borderDashOffset: 0,
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  hitTolerance: 0,
  init: void 0,
  pointStyle: "circle",
  radius: 10,
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  xAdjust: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  xValue: void 0,
  yAdjust: 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  yValue: void 0,
  z: 0
};
nt.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
class rt extends j {
  inRange(t, o, n, r) {
    if (n !== "x" && n !== "y")
      return this.options.radius >= 0.1 && this.elements.length > 1 && Vo(this.elements, t, o, r);
    const i = Y({ x: t, y: o }, this.getCenterPoint(r), w(-this.options.rotation)), s = this.elements.map((l) => n === "y" ? l.bY : l.bX), a = Math.min(...s), d = Math.max(...s);
    return i[n] >= a && i[n] <= d;
  }
  getCenterPoint(t) {
    return O(this, t);
  }
  draw(t) {
    const { elements: o, options: n } = this;
    t.save(), t.beginPath(), t.fillStyle = n.backgroundColor, E(t, n);
    const r = v(t, n);
    let i = !0;
    for (const s of o)
      i ? (t.moveTo(s.x, s.y), i = !1) : t.lineTo(s.x, s.y);
    t.closePath(), t.fill(), r && (t.shadowColor = n.borderShadowColor, t.stroke()), t.restore();
  }
  resolveElementProperties(t, o) {
    const n = xe(t, o), { sides: r, rotation: i } = o, s = [], a = 2 * b / r;
    let d = i * qt;
    for (let l = 0; l < r; l++, d += a) {
      const c = No(n, o, d);
      c.initProperties = _(t, n, o), s.push(c);
    }
    return n.elements = s, n;
  }
}
rt.id = "polygonAnnotation";
rt.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  hitTolerance: 0,
  init: void 0,
  point: {
    radius: 0
  },
  radius: 10,
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  sides: 3,
  xAdjust: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  xValue: void 0,
  yAdjust: 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  yValue: void 0,
  z: 0
};
rt.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
function No({ centerX: e, centerY: t }, { radius: o, borderWidth: n, hitTolerance: r }, i) {
  const s = (n + r) / 2, a = Math.sin(i), d = Math.cos(i), l = { x: e + a * o, y: t - d * o };
  return {
    type: "point",
    optionScope: "point",
    properties: {
      x: l.x,
      y: l.y,
      centerX: l.x,
      centerY: l.y,
      bX: e + a * (o + s),
      bY: t - d * (o + s)
    }
  };
}
function Vo(e, t, o, n) {
  let r = !1, i = e[e.length - 1].getProps(["bX", "bY"], n);
  for (const s of e) {
    const a = s.getProps(["bX", "bY"], n);
    a.bY > o != i.bY > o && t < (i.bX - a.bX) * (o - a.bY) / (i.bY - a.bY) + a.bX && (r = !r), i = a;
  }
  return r;
}
const C = {
  box: $,
  doughnutLabel: ot,
  ellipse: J,
  label: B,
  line: F,
  point: nt,
  polygon: rt
};
Object.keys(C).forEach((e) => {
  Se.describe(`elements.${C[e].id}`, {
    _fallback: "plugins.annotation.common"
  });
});
const Lo = {
  update: Object.assign
}, Bo = Mt.concat(G), Ft = (e, t) => I(t) ? yt(e, t) : e, xt = (e) => e === "color" || e === "font";
function Ct(e = "line") {
  return C[e] ? e : (console.warn(`Unknown annotation type: '${e}', defaulting to 'line'`), "line");
}
function Fo(e, t, o, n) {
  const r = qo(e, o.animations, n), i = t.annotations, s = Qo(t.elements, i);
  for (let a = 0; a < i.length; a++) {
    const d = i[a], l = me(s, a, d.type), c = d.setContext(Go(e, l, s, d)), h = l.resolveElementProperties(e, c);
    h.skip = Jo(h), "elements" in h && (Uo(l, h.elements, c, r), delete h.elements), m(l.x) || Object.assign(l, h), Object.assign(l, h.initProperties), h.options = ve(c), r.update(l, h);
  }
}
function Jo(e) {
  return isNaN(e.x) || isNaN(e.y);
}
function qo(e, t, o) {
  return o === "reset" || o === "none" || o === "resize" ? Lo : new Me(e, t);
}
function Uo(e, t, o, n) {
  const r = e.elements || (e.elements = []);
  r.length = t.length;
  for (let i = 0; i < t.length; i++) {
    const s = t[i], a = s.properties, d = me(r, i, s.type, s.initProperties), l = o[s.optionScope].override(s);
    a.options = ve(l), n.update(d, a);
  }
}
function me(e, t, o, n) {
  const r = C[Ct(o)];
  let i = e[t];
  return (!i || !(i instanceof r)) && (i = e[t] = new r(), Object.assign(i, n)), i;
}
function ve(e) {
  const t = C[Ct(e.type)], o = {};
  o.id = e.id, o.type = e.type, o.drawTime = e.drawTime, Object.assign(
    o,
    yt(e, t.defaults),
    yt(e, t.defaultRoutes)
  );
  for (const n of Bo)
    o[n] = e[n];
  return o;
}
function yt(e, t) {
  const o = {};
  for (const n of Object.keys(t)) {
    const r = t[n], i = e[n];
    xt(n) && W(i) ? o[n] = i.map((s) => Ft(s, r)) : o[n] = Ft(i, r);
  }
  return o;
}
function Go(e, t, o, n) {
  return t.$context || (t.$context = Object.assign(Object.create(e.getContext()), {
    element: t,
    get elements() {
      return o.filter((r) => r && r.options);
    },
    id: n.id,
    type: "annotation"
  }));
}
function Qo(e, t) {
  const o = t.length, n = e.length;
  if (n < o) {
    const r = o - n;
    e.splice(n, 0, ...new Array(r));
  } else n > o && e.splice(o, n - o);
  return e;
}
var Ko = "3.1.0";
const S = /* @__PURE__ */ new Map(), Jt = (e) => e.type !== "doughnutLabel", Zo = Mt.concat(G);
var rn = {
  id: "annotation",
  version: Ko,
  beforeRegister() {
    Ie("chart.js", "4.0", st.version);
  },
  afterRegister() {
    st.register(C);
  },
  afterUnregister() {
    st.unregister(C);
  },
  beforeInit(e) {
    S.set(e, {
      annotations: [],
      elements: [],
      visibleElements: [],
      listeners: {},
      listened: !1,
      moveListened: !1,
      hooks: {},
      hooked: !1,
      hovered: []
    });
  },
  beforeUpdate(e, t, o) {
    const n = S.get(e), r = n.annotations = [];
    let i = o.annotations;
    I(i) ? Object.keys(i).forEach((s) => {
      const a = i[s];
      I(a) && (a.id = s, r.push(a));
    }) : W(i) && r.push(...i), po(r.filter(Jt), e.scales);
  },
  afterDataLimits(e, t) {
    const o = S.get(e);
    yo(e, t.scale, o.annotations.filter(Jt).filter((n) => n.display && n.adjustScaleRange));
  },
  afterUpdate(e, t, o) {
    const n = S.get(e);
    co(e, n, o), Fo(e, n, o, t.mode), n.visibleElements = n.elements.filter((r) => !r.skip && r.options.display), xo(e, n, o);
  },
  beforeDatasetsDraw(e, t, o) {
    N(e, "beforeDatasetsDraw", o.clip);
  },
  afterDatasetsDraw(e, t, o) {
    N(e, "afterDatasetsDraw", o.clip);
  },
  beforeDatasetDraw(e, t, o) {
    N(e, t.index, o.clip);
  },
  beforeDraw(e, t, o) {
    N(e, "beforeDraw", o.clip);
  },
  afterDraw(e, t, o) {
    N(e, "afterDraw", o.clip);
  },
  beforeEvent(e, t, o) {
    const n = S.get(e);
    ho(n, t.event, o) && (t.changed = !0);
  },
  afterDestroy(e) {
    S.delete(e);
  },
  getAnnotations(e) {
    const t = S.get(e);
    return t ? t.elements : [];
  },
  // only for testing
  _getAnnotationElementsAtEventForMode(e, t, o) {
    return gt(e, t, o);
  },
  defaults: {
    animations: {
      numbers: {
        properties: ["x", "y", "x2", "y2", "width", "height", "centerX", "centerY", "pointX", "pointY", "radius"],
        type: "number"
      },
      colors: {
        properties: ["backgroundColor", "borderColor"],
        type: "color"
      }
    },
    clip: !0,
    interaction: {
      mode: void 0,
      axis: void 0,
      intersect: void 0
    },
    common: {
      drawTime: "afterDatasetsDraw",
      init: !1,
      label: {}
    }
  },
  descriptors: {
    _indexable: !1,
    _scriptable: (e) => !Zo.includes(e) && e !== "init",
    annotations: {
      _allKeys: !1,
      _fallback: (e, t) => `elements.${C[Ct(t.type)].id}`
    },
    interaction: {
      _fallback: !0
    },
    common: {
      label: {
        _indexable: xt,
        _fallback: !0
      },
      _indexable: xt
    }
  },
  additionalOptionScopes: [""]
};
function N(e, t, o) {
  const { ctx: n, chartArea: r } = e, i = S.get(e);
  o && Te(n, r);
  const s = tn(i.visibleElements, t).sort((a, d) => a.element.options.z - d.element.options.z);
  for (const a of s)
    en(n, r, i, a);
  o && De(n);
}
function tn(e, t) {
  const o = [];
  for (const n of e)
    if (n.options.drawTime === t && o.push({ element: n, main: !0 }), n.elements && n.elements.length)
      for (const r of n.elements)
        r.options.display && r.options.drawTime === t && o.push({ element: r });
  return o;
}
function en(e, t, o, n) {
  const r = n.element;
  n.main ? (Xt(o, r, "beforeDraw"), r.draw(e, t), Xt(o, r, "afterDraw")) : r.draw(e, t);
}
export {
  rn as default
};
//# sourceMappingURL=index.es67.js.map
